module.exports = __webpack_public_path__ + "static/media/carta_26.feba46e0.jpg";